/**
 * Formata números de telefone brasileiros e americanos com os códigos de país.
 * @param {string} number - Número de telefone para formatação.
 * @param {string} format - Formato esperado ('usa', 'br', ou vazio).
 * @returns {string} Número formatado.
 */
const formatPhone = (number, format = '') => {
    // Remove caracteres não numéricos
    const cleanedNumber = number.replace(/\D/g, '');
  
    // Verifica o formato especificado
    if (format.toLowerCase() === 'usa') {
      return formatUSA(cleanedNumber);
    } else if (format.toLowerCase() === 'br') {
      return formatBrazilian(cleanedNumber);
    }
  
    // Validação automática pelo primeiro dígito
    const firstDigit = cleanedNumber[0];
    if (firstDigit === '1') {
      return formatUSA(cleanedNumber);
    }
  
    return formatBrazilian(cleanedNumber);
  };
  
  // Formatação de número brasileiro
  const formatBrazilian = (number) => {
    const brazilianPattern = /^(\d{2})(\d{4,5})(\d{4})$/;
    const matches = number.match(brazilianPattern);

    if(number.startsWith('55')){
      return `+${number}`;
    } else if (matches) {
      const [, areaCode, firstPart, secondPart] = matches;
      return `+55 (${areaCode}) ${firstPart}-${secondPart}`;
    } else {
      return number;
    }
  
    // throw new Error('Invalid Brazilian phone number format.');
  };
  
  // Formatação de número americano
  const formatUSA = (number) => {
    if (number.startsWith('55')) {
      number = number.slice(2); // Remove o código de país do Brasil
    } 

    const usaPattern = /^1(\d{3})(\d{3})(\d{4})$/;
    const matches = number.match(usaPattern);
    
    if (matches) {
      const [, areaCode, firstPart, secondPart] = matches;
      return `+1 (${areaCode}) ${firstPart}-${secondPart}`;
    } else {
      return number;
    }
  
    // throw new Error('Invalid USA phone number format.');
  };
  
  export default formatPhone;
  